import { Anchor, Card, CardBody, CardHeader, CardTitle } from "@govlaunch/web";
import { BoxProps } from "@govlaunch/web/src/box/Box";
import React, { ReactNode } from "react";
import { IProductFieldsFragment } from "../fragments/__generated__/ProductFieldsFragment.generated";
import { FormattedMessage } from "react-intl";

interface IProductSiblingsCardProps extends BoxProps {
  product: IProductFieldsFragment;
  renderLinkWrap?: (sibling: NonNullable<IProductFieldsFragment["siblings"]>[0], children: ReactNode) => ReactNode;
}

export default function ProductSiblingsCard({ product, renderLinkWrap }: IProductSiblingsCardProps) {
  const siblings = product.siblings || [];

  if (siblings.length === 0) {
    return null;
  }

  return (
    <Card mt={4}>
      <CardHeader>
        <CardTitle>
          <FormattedMessage
            defaultMessage="More By {companyName}" id="gRkbZU"
            values={{
              companyName: product.company?.name,
            }}
          />
        </CardTitle>
      </CardHeader>

      <CardBody>
        <ul css={{ listStyleType: "none" }}>
          {siblings.map(sibling => {
            const anchor = (
              <Anchor href={`/products/${product.slug}`} fontSize="sm">
                {sibling.name}
              </Anchor>
            );

            return <li key={sibling._id}>{renderLinkWrap ? renderLinkWrap(sibling, anchor) : anchor}</li>;
          })}
        </ul>
      </CardBody>
    </Card>
  );
}
